import ProductMigrationLogState from '@/models/Products/ProductMigrations/ProductMigrationLogState';

export default (productMigrationLogState: ProductMigrationLogState) => {
    let returnVal = "Undefined";
    switch (productMigrationLogState) {
        case ProductMigrationLogState.Information:
            returnVal = "Information"
            break;
        case ProductMigrationLogState.Warning:
            returnVal = "Warning"
            break;
        case ProductMigrationLogState.Error:
            returnVal = "Error"
            break;
    }
    return returnVal;
}